import { format, isAfter } from 'date-fns'
import { MINUTE } from '../constants'
import TramIcon from './../../src/assets/images/TramIcon.svg'
import BusIcon from './../../src/assets/images/BusIcon.svg'

export const filterPassedPassages = (lines, error, currentTime) => {
  return lines.filter((line) => {
    const departure =
      line.vertrekRealtimeTijdstip || line.vertrekTheoretischeTijdstip
    const time = error ? Date.now() : currentTime
    return isAfter(departure, time)
  })
}

export const filterLinesBefore = (lines, time) => {
  return lines.filter((line) => {
    const departure =
      line.vertrekRealtimeTijdstip || line.vertrekTheoretischeTijdstip
    return isAfter(departure, time)
  })
}

export const getDepartureTime = (theoreticalTime, realtime, currentTime) => {
  if (Math.round((theoreticalTime - currentTime) / MINUTE) > 60) {
    return format(theoreticalTime, 'HH:mm')
  }
  if (!realtime) {
    return format(theoreticalTime, 'HH:mm')
  }
  const diffInMinutes = Math.round((realtime - currentTime) / MINUTE)
  const departureTime = diffInMinutes <= 0 ? 0 : diffInMinutes
  return Number(departureTime)
}

export function calculateDeviationInMinutes(
  theoreticalDepartureTime,
  realtimeDepartureTime,
) {
  if (!theoreticalDepartureTime || !realtimeDepartureTime) {
    return undefined
  }
  return Math.round((realtimeDepartureTime - theoreticalDepartureTime) / MINUTE)
}

export const getDelayColor = (delay, lightMode) => {
  if (delay > 0) {
    return lightMode ? '#EF3934' : '#F69B99'
  } else if (delay < 0) {
    return '#86A3F8'
  } else {
    return '#77CC00'
  }
}

export const isArrivingAtStop = (realtime, currentTime) => {
  const TWO_MINUTES = 120
  if (!realtime) {
    return false
  }
  return Math.round((realtime - currentTime) / 1000) < TWO_MINUTES
}

export const renderTransportUtils = (transportType) => {
  if (transportType === 'TRAM') {
    return {
      icon: TramIcon,
      testId: 'tram-icon',
      alt: 'tram transport type ',
    }
  } else if (transportType === 'BUS') {
    return {
      icon: BusIcon,
      testId: 'bus-icon',
      alt: 'bus transport type ',
    }
  } else {
    return undefined
  }
}
